export const CONTACTS_TABLE_TYPE = {
  FRIENDS: 'friends',
  RECEIVED_APPLICATION: 'receivedApplication',
  SENT_APPLICATION: 'sentApplication',
  SEARCH_USERS: 'searchUsers',
};

export const ONLINE_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline',
};

export const CONTACTS_STATUS = {
  FRIEND: 'FRIEND',
  RECEIVED: 'RECEIVED',
  WAITING: 'WAITING',
  SENT: 'SENT',
};
